import React, { useContext } from "react";
import Table from 'react-bootstrap/Table';
import { QuizContext } from "../../App";

const TableMembershipPlans = () => {

  const quizContext = useContext(QuizContext);
  const theme = quizContext.state.theme;

  return (
    <div style={{ overflowX: "auto" }}>
      <div className="data-table">
        <Table
          striped
          variant={theme}
          className="table table-bordered"
        >
          <thead>
            <tr style={{ fontSize: "0.9rem" }}>
              <th className="table-fontsize">Статус пользовталя</th>
              <th className="table-fontsize">Количество команд</th>
              <th className="table-fontsize">Количество членов команды</th>
              <th className="table-fontsize">Количество ОБЩЕДОСТУПНЫХ квизов</th>
              <th className="table-fontsize">Количество заработанных очков</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="table-fontsize">УЧЕНИК</td>
              <td className="table-fontsize">макс. {quizContext.state.membPlan.student.teams}</td>
              <td className="table-fontsize">макс. {quizContext.state.membPlan.student.members}</td>
              <td className="table-fontsize">мин. {quizContext.state.membPlan.student.quizzes}</td>
              <td className="table-fontsize">мин. {quizContext.state.membPlan.student.points}</td>
            </tr>
            <tr>
              <td className="table-fontsize">БРОНЗОВЫЙ</td>
              <td className="table-fontsize">макс. {quizContext.state.membPlan.bronze.teams}</td>
              <td className="table-fontsize">макс. {quizContext.state.membPlan.bronze.members}</td>
              <td className="table-fontsize">мин. {quizContext.state.membPlan.bronze.quizzes}</td>
              <td className="table-fontsize">мин. {quizContext.state.membPlan.bronze.points}</td>
            </tr>
            <tr>
              <td className="table-fontsize">СЕРЕБРЯННЫЙ</td>
              <td className="table-fontsize">макс. {quizContext.state.membPlan.silver.teams}</td>
              <td className="table-fontsize">макс. {quizContext.state.membPlan.silver.members}</td>
              <td className="table-fontsize">мин. {quizContext.state.membPlan.silver.quizzes}</td>
              <td className="table-fontsize">мин. {quizContext.state.membPlan.silver.points}</td>
            </tr>
            <tr>
              <td className="table-fontsize">ЗОЛОТОЙ</td>
              <td className="table-fontsize">макс. {quizContext.state.membPlan.gold.teams}</td>
              <td className="table-fontsize">макс. {quizContext.state.membPlan.gold.members}</td>
              <td className="table-fontsize">мин. {quizContext.state.membPlan.gold.quizzes}</td>
              <td className="table-fontsize">мин. {quizContext.state.membPlan.gold.points}</td>
            </tr>
            <tr>
              <td className="table-fontsize">ГУРУ</td>
              <td className="table-fontsize">макс. {quizContext.state.membPlan.guru.teams}</td>
              <td className="table-fontsize">макс. {quizContext.state.membPlan.guru.members}</td>
              <td className="table-fontsize">мин. {quizContext.state.membPlan.guru.quizzes}</td>
              <td className="table-fontsize">мин. {quizContext.state.membPlan.guru.points}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  )
}

export default TableMembershipPlans